import { bathrooms } from "./bathrooms";
import { closets } from "./closets";
import { kitchens } from "./kitchens";

export const services = {
  kitchens,
  bathrooms,
  closets,
  highlights: [kitchens[0], kitchens[3], kitchens[2]],
};
